export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ItemDetail.vue?vue&type=template&id=7512cc08&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/ItemDetail.vue?vue&type=template&id=7512cc08&
// module id = null
// module chunks = 